import { memo } from 'react'
import styled from 'styled-components'

import WalletContent from 'components/wallet/Content'
import { useAccountSection, ACCOUNT_SECTIONS } from 'components/account/context'

import Profile from './Profile'
import Settings from './Settings'
import Security from './Security'
import { Container, TabContent } from './Styles'

// The Wallet & Analytics area is designed as a standalone page (it carries a
// large top margin meant to sit below the TopBar and its own horizontal
// padding). When embedded inside the account body we neutralise both so it
// lines up with the rest of the content.
const WalletWrapper = styled.div`
  & [data-cy='walletContent'] {
    margin-top: 0;
    padding-left: 0;
    padding-right: 0;
    min-height: auto;
  }
`

// Renders the active account section. Which section is shown is controlled by
// the account sidebar (components/doctorProfile/Sidebar) through the shared
// AccountSection context — there is no in-page tab bar.
const Body = () => {
  const { section } = useAccountSection()

  const renderSection = () => {
    switch (section) {
      case ACCOUNT_SECTIONS.WALLET:
        return (
          <WalletWrapper>
            <WalletContent />
          </WalletWrapper>
        )
      case ACCOUNT_SECTIONS.SETTINGS:
        return <Settings />
      case ACCOUNT_SECTIONS.SECURITY:
        return <Security />
      case ACCOUNT_SECTIONS.PROFILE:
      default:
        return <Profile />
    }
  }

  return (
    <Container>
      <TabContent>{renderSection()}</TabContent>
    </Container>
  )
}

Body.whyDidYouRender = true

export default memo(Body)
